class MainCollectionProductGrid {
  constructor() {
    this.clickEvent();
    this.pBanner = [];
    this.onLoad();
  }
  clickEvent = () => {
    let numOfColIcon = qsa('.grid-icons li');
    numOfColIcon.length > 0 && numOfColIcon.forEach(el => {
      el.addEventListener('click',(e)=> {
        let columns = [];
        if (window.getCookie('grid-columns')) {
          columns = JSON.parse(window.getCookie('grid-columns'))
        }
        let dataColumns = el.getAttribute("data-columns");
        let productGrid = qs('#product-grid');
        numOfColIcon.forEach(item => {
          if (item == el) {
            el.classList.add('active');
            productGrid?.classList.forEach(cl=>{
              if (cl.includes('-col-desktop') && window.innerWidth > 989) {
                productGrid.classList.remove(cl);
              }
              if (cl.includes('-col-tablet-down') && window.innerWidth < 990) {
                productGrid.classList.remove(cl);
              }
            })
            if (dataColumns == '1') {
              this.pBanner = qsa('.promotional-banner-list',productGrid);
              this.pBanner.length > 0 && this.pBanner.forEach(pb => pb.remove());
            }else {
              this.pBanner.length > 0 && this.pBanner.forEach((pb,i) => {
                let bannerPosition = parseInt(pb.getAttribute('banner-position'));
                let referenceNode = productGrid.children[bannerPosition - 1 + i];
                productGrid.insertBefore(pb, referenceNode);
              });
            }
            if (window.innerWidth < 990) {
              productGrid.classList.add(`grid--${dataColumns}-col-tablet-down`);
              columns[0] = dataColumns;
            }else {
              qsa('.grid__item .card-wrapper .card__content',productGrid).forEach(cardEl=>{
                if (dataColumns == "6") {
                  cardEl.classList.add('large-up-hide');
                }else {
                  cardEl.classList.remove('large-up-hide');
                }
              })
              productGrid.classList.add(`grid--${dataColumns}-col-desktop`);
              columns[1] = dataColumns;
            }
            window.setCookie('grid-columns',JSON.stringify(columns));
          }else {
            item.classList.remove('active','mob-active');
          }
        });
        if (theme.bannerHeight) theme.bannerHeight();
      })
    });

    if (document.querySelector('.content-read-more-liquid')) {
      document.querySelector('.content-read-more-liquid').style.visibility='visible';
      let reads = document.querySelectorAll('.readmore');
      let reads2 = document.querySelectorAll('.readless');
      let contents = document.querySelectorAll('.content .hide_content');
      reads.forEach((read,index)=> {
        read.addEventListener('click', () => {
        contents[index].style.display="inline-block";
          read.style.display="none";
          read.closest('.content_wrapper').querySelector('.readless').style.display="inline-block";
        });
      });

      reads2.forEach((readd,indexd)=>{
        readd.addEventListener('click', () => {
          contents[indexd].style.display="none";
          readd.style.display="none";
          readd.closest('.content_wrapper').querySelector('.readmore').style.display= 'inline-block';
        });
      });
    }

    document.addEventListener('click',(e)=> {
      if (e.target.closest('swatch-card-product') && setCookie) {
        let url = e.target.closest('swatch-card-product a')?.href;
        let scrollPosition = {
          url,
          sP: window.scrollY
        }
        setCookie('scrollPosition',JSON.stringify(scrollPosition));
      }
    })

  }
  onLoad = () => {
    if (!window.getCookie('grid-columns')) {
      let numOfColIcon = qsa('.grid-icons li');
      let columns = [];
      numOfColIcon.length > 0 && numOfColIcon.forEach(el => {
        if (el.classList.contains('mob-active')) {
          let dataColumns = parseInt(el.getAttribute("data-columns"));
          columns[0] = dataColumns;
        }
        if (el.classList.contains('active')) {
          let dataColumns = parseInt(el.getAttribute("data-columns"));
          columns[1] = dataColumns;
        }
      });
      window.setCookie('grid-columns',JSON.stringify(columns));
    }else {
      let columns = JSON.parse(window.getCookie('grid-columns'));
      if (window.innerWidth < 990) {
        qs(`.grid-icons [data-columns="${columns[0]}"]`)?.click();
      }else {
        qs(`.grid-icons [data-columns="${columns[1]}"]`)?.click();
      }
    }
    if (theme.retrieveScrollPosition) theme.retrieveScrollPosition();
  }
  discriptionMoreLessContent = () => {
    document.addEventListener("click", (e) => {
      if(e.target.closest(".read_toggle")){
        let parent = e.target.closest(".content-read-more-liquid")
        let readmoreBtns = parent.querySelectorAll(".read_toggle")
        let showContent = parent.querySelector('.show_content')
        let hideContent =  parent.querySelector('.hide_content')
        showContent && showContent.classList.add("hide_content")
        showContent && showContent.classList.remove("show_content")
        hideContent && hideContent.classList.add("show_content")
        hideContent && hideContent.classList.remove("hide_content")
        readmoreBtns.forEach((el)=>{
          el.classList.remove("hide_content")
        })
        e.target.closest(".read_toggle").classList.add("hide_content")
      }
    })
  }
}
if (qs('.main-collection-product-grid') || qs('.template-search')) new MainCollectionProductGrid();
if (qs('.promotional-banner-list') && theme) {
  theme.bannerHeight = () => {
    setTimeout(() => {
      if(window.innerWidth > 767){
        qsa('.promotional-banner-list').forEach(el => {
          let offsetHeight = qs('.grid__item .card__inner')?.offsetHeight;
          if (offsetHeight && qs('img',el)) qs('img',el).style.height = `${offsetHeight}px`;
        })
      }
    }, 500);
  }
  theme.bannerHeight();
  window.addEventListener("resize", theme.bannerHeight);
}